<template>
  <div class="footer-out">
    <div class="foot">
      <div class="txt">
        <div @click="change">
          <div class="text">恒生家族</div>
          <div class="img">
            <img src="../assets/imgapp/foot-t.png" alt="" />
          </div>
        </div>
        <div class="yin" :class="flg ? 'active' : ''">
          <div
            class="list"
            v-for="(item, index) in family"
            :key="index"
            @click="tolink(item.link)"
          >
            <div class="text">{{ item.title }}</div>
            <div class="img">
              <img src="../assets/imgapp/foot-r.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="f_txt">
        <div class="txt_1">ADDRESS</div>
        <div class="txt_2" v-html="other.description">
          <!-- 杭州市（滨江）江南大道3588号恒生大厦<br>
           Hundsun Tower,3588,Jiangnan<br>
          Ave.,Binjiang Dist.,Hangzhou,China -->
        </div>
        <div class="txt_3">
          Copyright 1999-2021 HUNDSUN 版权所有 <a style="color:#737373;" href="https://beian.miit.gov.cn">浙ICP备09092082号-5</a>
          <!-- {{copyright}} -->
        </div>
        <p id="cnzz_box" ref="cnzz"></p>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/js/cnzz.js'
export default {
  data() {
    return {
      family: [],
      other: {},
      copyright: "",
      flg: false,
    };
  },
  mounted() {
    this.getData();
     cnzz_box.append(cnzz_stat_icon_1982421);
  },
  methods: {
    getData() {
      this.$fetch({
        url: "index.php/common/initGuideAndFoot",
        loading: false,
      }).then((res) => {
        //console.log(res);
        if (res.code == 0) {
          this.family = res.data.foot_links;
          this.other = res.data.foot_other;
          this.copyright = res.data.foot_copyright;
        }
      });
    },
    change() {
      this.flg = !this.flg;
    },
    tolink(url) {
      window.open(url, "_block");
    },
  },
};
</script>
<style scoped>
.foot {
  height: auto;
  background: #050d17;
  padding-bottom: 98px;
}
.foot .txt {
  padding-top: 40px;
}
.foot .txt > div {
  width: 690px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.foot .txt > div:nth-child(1) {
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.3);
}
.foot .txt .text {
  font-size: 28px;
  color: #ffffff;
  line-height: 40px;
  padding: 30px 0;
}
.foot .txt .img img {
  width: 16px;
  height: 9px;
}
.foot .yin {
  height: 0;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  transition: height 0.3s linear;
}
.foot .active {
  height: 1000px;
}
.foot .yin .text {
  color: #8e9296;
}
.foot .yin .img img {
  width: 9px;
  height: 16px;
}
.foot .yin .list {
  display: block;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #2e353d;
}
.foot .f_txt {
  padding: 0 0 0 30px;
}
.foot .f_txt .txt_1 {
  font-size: 28px;
  color: #ffffff;
  line-height: 40px;
  margin: 63px 0 29px 0;
}
.foot .f_txt .txt_2 {
  font-size: 24px;
  font-weight: 400;
  color: hsl(0, 0%, 60%);
  line-height: 33px;
}
.foot .f_txt .txt_3 {
  font-size: 24px;
  font-weight: 400;
  color: hsl(0, 0%, 45%);
  line-height: 33px;
  padding: 57px 0 49px 0;
}
</style>